<div id="account" style="margin-top: 5rem;" >
    <app-account></app-account>
</div>
<div id="accountStyles" #container></div>
<!-- <div id="account" style="display: none; margin-top: 3rem;">
    <app-header title=""></app-header>
    <div class="row pt-4 px-5">
        <div class="col">
            <ul class="nav account-custom-nav" style="border-bottom: #9e9e9e45 1px solid;">
                <li class="nav-item">
                    <a class="nav-link active" data-toggle="tab" href="#panelOrgInfo" role="tab">Organization Info</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" data-toggle="tab" href="#panelPasswordChange" role="tab">Change Password</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" data-toggle="tab" href="#panelOrgNotifications" role="tab">Notifications</a>
                </li>
            </ul>

            <div class="tab-content">
                <div class="tab-pane fade in show active" id="panelOrgInfo" role="tabpanel">
                    <div class="row justify-content-left" style="background-color: yellow;">
                        <div class="col">
                            <div class="row justify-content-center align-items-center mt-2">
                                <div class="col text-center h5">
                                    Annual Tax Receipt to Donors
                                </div>
                            </div>
                            <div class="row justify-content-center align-items-center mb-2">
                                <div class="col text-center">
                                    We send consolidated annual tax receipts for all donations recorded in PayBee for donors in the third week of January. Everyone is opted in by default.
                                </div>
                            </div>
                            <div class="row justify-content-center align-items-center">
                                <div class="col text-right h6" id="optedOutTaxReceiptText">
                                    Opt out of annual Tax Receipt.
                                </div>
                                <div class="col tax-left">
                                    <a id="otpOutTaxReceiptButton" class="btn btn-sm btn-success">Opt Out</a>
                                </div>                                                    
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <form class="block container" action='' onsubmit="return false" method="POST">
                            <div class="row">
                                <div class="col">
                                    <div class="md-form">
                                        <img class="accountCoverImage" src="/images/org_logo_default_v2.svg" id="accountUserImage">
                                        <div class='file-field'>
                                            <div class='d-flex justify-content-left'>
                                                <div class='btn btn-flat' style='margin-left: 0px; padding-left: 0px; padding-top: 0px;'>
                                                    <span class='blue-text'>Select Cover Image</span>
                                                    <input #selectCoverImage id='selectCoverImage' [(ngModel)]="selectCoverImageValue" accept="image/png,image/jpeg" type='file' onclick='this.value=null;'>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="md-form">
                                        <img class="accountLogo" src="/images/logo_blank.png" id="accountLogo">
                                        <div class='file-field'>
                                            <div class='d-flex justify-content-left'>
                                                <div class='btn btn-flat' style='margin-left: 0px; padding-left: 0px; padding-top: 0px;'>
                                                    <span class='blue-text'>Select Logo</span>
                                                    <input id='selectedLogo' #selectedLogo [(ngModel)]="selectedLogoValue" accept="image/png,image/jpeg" type='file' onclick='this.value=null;'>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row justify-content-left mb-4">
                                <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8 col-xl-8">
                                    <div>
                                        <span>Account Banner Color</span>
                                        <br>
                                        <span class="small text-muted">
                                            Used for top banner for donation pages & email headers.
                                            <a id="colochangePreview" href="#" target="_blank">Preview</a> after the update.
                                        </span>
                                    </div>
                                    <div class="row justify-content-left mt-2">
                                        <div class="col">
                                            <div class="text-muted small mb-1" style="font-weight: 300;">Background Color</div>
                                            <input type='text' id="banner-bk-color-picker"/>
                                        </div>
                                        <div class="col">
                                            <div class="text-muted small mb-1" style="font-weight: 300;">Text Color</div>
                                            <input type='text' id="banner-text-color-picker"/>
                                        </div>
                                    </div>                                                
                                </div>
                            </div>
                            <div class="row justify-content-left">
                                <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8 col-xl-8 custom-material-form updated-dropdown">
                                    <div class="md-form custom-character-counter">
                                        <input type="text" id="accountName" maxlength="127" length="127" required class="form-control validate" style="position:relative">
                                        <label id="accountNameLabel" class="inputLabel" for="accountName" data-error="Invalid" data-success="">
                                            Organization Name
                                        </label>
                                    </div>
                                    <div class="md-form">
                                        <input type="email" id="accountEmail" required class="form-control validate">
                                        <label id="accountEmailLabel" class="inputLabel" for="accountEmail" data-error="Invalid" data-success="">
                                            Account Email
                                        </label>
                                    </div>
                                    <div class="md-form custom-character-counter">
                                        <input type="text" id="accountMission" maxlength="256" length="256" required class="form-control validate">
                                        <label id="accountMissionLabel" class="inputLabel" for="accountMission" data-error="Invalid" data-success="">
                                            Short Mission statement
                                        </label>
                                    </div>
                                    <div class="md-form mb-5 custom-character-counter">
                                        <input type="text" id="accountUrl" maxlength="127" length="127" required class="form-control validate">
                                        <label id="accountUrlLabel" class="inputLabel" for="accountUrl" data-error="Invalid" data-success="">
                                            Website URL
                                        </label>
                                    </div>
                                    <div class="md-form pt-4 quill-editor--paybee">
                                        <div id="accountDescription" class="form-control md-textarea resize-vertical overflow-visible mb-0 ">
                                        </div>
                                        <label id="accountDescriptionLabel" for="accountDescription" style="font-size: 20px;" class="inputLabel active">
                                            Account description
                                        </label>
                                        <span id="accountDescriptionLength"  class="character-counter character-counter-jquery"></span>
                                    </div>
                                    <div class="form-group text-center mt-4">
                                        <button #accountUpdateButton id="accountUpdateButton" class="btn btn-rounded btn-info waves-effect waves-light" type="submit">Update</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="tab-pane fade" id="panelPasswordChange" role="tabpanel">
                    <div class="row">
                        <div class="col-xs-11 col-sm-10 col-md-8 col-lg-6 col-xl-6 custom-material-form updated-dropdown">
                            <form id="cpForm" #cpForm action='' onsubmit="return false" method="POST">
                            <div class="md-form form-sm inputCustom">
                                <input type="password" id="currentPasswd" class="form-control validate">
                                <label id="currentPasswdLabel" class="inputLabel" for="currentPasswd" data-error="invalid" data-success="">
                                    Current password
                                </label>
                            </div>
                            <div class="md-form form-sm inputCustom">
                                <input type="password" id="newPassword" class="form-control validate">
                                <label id="newPasswordLabel" class="inputLabel" for="newPassword" data-error="invalid" data-success="">
                                    New password
                                </label>
                            </div>
                            <div class="md-form form-sm inputCustom">
                                <input type="password" id="newRepeatPassword" class="form-control validate">
                                <label id="newRepeatPasswordLabel" class="inputLabel" for="newRepeatPassword" data-error="invalid" data-success="">
                                    Repeat password
                                </label>
                            </div>
                            <div class="text-center md-form">
                                <button type="submit"  class="btn btn-primary text-center">Change Password</button>
                            </div>
                        </form>
                        </div>
                    </div>
                </div>
                <div class="tab-pane fade" id="panelOrgNotifications" role="tabpanel">
                    <h4>Add email Ids to be notified for each successful transaction.</h4>
                    <p class="mb-4">Type a email and press enter to add. Click <strong>X</strong> to remove it.</p>
                    <div id="notifyTransactionsChip" class="chips">
                    </div>
                    <small class="red-text" id="notifyTransactionsError" style="display: none">
                    </small>
                    <div class="form-group text-center mt-4">
                        <button id="updateNotifyTransaction" class="btn btn-rounded btn-info waves-effect waves-light">
                            Update
                        </button>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div> -->